import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 4px;
  display: flex;
  justify-content: flex-end;
`;
